import React, { useState, useEffect } from 'react';
import classNames from 'classnames/bind';
import {
  params, shape, arrayOf, string as stringType, useDataModel
} from '@thd-nucleus/data-sources';
import { Heading } from '@thd-olt-component-react/heading';
import { withDynamicComponent } from '@thd-nucleus/app-render';
import { withHydrator } from '@thd-olt-component-react/hydrator';
import { LoadingPlaceholder } from '@thd-olt-component-react/loading-placeholder';
import styles from './store-directory.module.scss';

const cx = classNames.bind(styles);

const NationalDirectoryComponent = () => {
  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('store-directory.ready'); }, []);

  const { data, loading, error } = useDataModel('storeDirectory', {});
  const storeDirectory = data?.storeDirectory?.storeDirectory || [];

  if (loading) {
    return (
      <article className={cx('store-directory')}>
        <section className={cx('store-directory__header')}>
          <Heading title="Store Directory" />
        </section>
        <LoadingPlaceholder
          color="#E0E0E0"
          rows={15}
          ready={false}
          showLoadingAnimation
          style={{ height: 515 }}
          type="text"
        ><div />
        </LoadingPlaceholder>
      </article>
    );
  }
  if (!storeDirectory?.length || error) return null;

  return (
    <article className={cx('store-directory')}>
      <section className={cx('store-directory__header')}>
        <Heading title="Store Directory" />
      </section>

      <section className={cx('store-directory__state-wrapper')}>
        {storeDirectory.map(({ stateName, stateLink }, stateIndex) => {
          return (
            <div className={cx('store-directory__state')} key={`${stateName}-${stateIndex}`}>
              <a
                className={styles['store-directory__state-link']}
                id={`${stateName}-${stateIndex}`}
                href={stateLink}
              >
                {stateName}
              </a>
            </div>
          );
        })}
      </section>
    </article>
  );
};

NationalDirectoryComponent.displayName = 'NationalDirectory';

const dataModel = {
  storeDirectory: params().shape({
    storeDirectory: arrayOf(shape({
      stateName: stringType(),
      stateLink: stringType(),
    }))
  })
};

NationalDirectoryComponent.dataModel = dataModel;

const HydratedComponent = withHydrator({
  delay: 500,
  id: 'national-directory',
  placeholder: (
    <LoadingPlaceholder
      color="#f5f5f5"
      ready={false}
      style={{ height: 500 }}
      type="rect"
    ><div />
    </LoadingPlaceholder>
  ),
  scrollBuffer: 100,
}, NationalDirectoryComponent);

const NationalDirectory = withDynamicComponent(HydratedComponent);

NationalDirectory.dataModel = dataModel;

export { NationalDirectory };
